import server from '../../public/server/server'
const GISApi = {
    //时空地图
	alarmOwn:server.requestPath+'/agg/alarmOwn',//当前指挥中心[指挥中心附]近的事件(报警事件)
	camera:server.requestPath+'/agg/camera',//摄像头-聚合
	stbMashup:server.requestPath+'/agg/stbMashup',//机顶盒-聚合
	neighborhood:server.requestPath+'/agg/neighborhood',//附近求助-
	boxStatistical:server.requestPath+'/agg/boxStatistical',//机顶盒/摄像机/-统计
	getStatistics:server.requestPath+'/agg/camera/getStatistics',//摄像机-详情
	gdMapView:server.requestPath+'/agg/gdMapView',//获取areaCode
	findLiveUrl:server.requestPath+'/camera/findLiveUrl',//摄像机-----查询摄像机的直播地址
	user:server.requestPath+'/agg/user',//用户聚合
	controlCenter:server.requestPath+'/agg/center',//指挥中心聚合
	centerUser:server.requestPath+'/agg/centerUser',//指挥中心接警人员
	storageStatistics:server.requestPath+'/cameraPlayback/storageStatistics',//统计

}

export {
    GISApi
}
